import {
  type LC_MarksManagerItem,
  type LC_ListMarksManagerOut,
  type MarksManagerRow,
  type MarksManagerPage,
} from '../types/marksManager.types';


export function mapMarksManagerRow(item: LC_MarksManagerItem): MarksManagerRow {
  return {
    employeeId: item.employeeId,
    rut: item.employeeTaxIdentificationNumber,
    fullName: item.fullName,
    date: item.date,
    plannedHours: item.plannedHours,
    workedHours: item.workedHours,
    // Passthrough only — no table column consumes this yet (see LC_MarksManagerItem docs).
    attendanceStatusCode: item.attendanceStatusCode,
    hasOvertimeHours: item.hasOvertimeHours,
    hasAbsentHours: item.hasAbsentHours,
  };
}

export function mapMarksManagerPage(data: LC_ListMarksManagerOut): MarksManagerPage {
  return {
    items: data.items.map(mapMarksManagerRow),
    pagination: {
      currentPage: data.pagination.currentPage,
      pageSize: data.pagination.pageSize,
      totalRecords: data.pagination.totalRecords,
      totalPages: data.pagination.totalPages,
      hasPreviousPage: data.pagination.hasPreviousPage,
      hasNextPage: data.pagination.hasNextPage,
    },
  };
}
